import template from './approve_leave.html';
import * as Utils from '../../lib/savanna_utils.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';
import tr from '../../lib/default-translator.js';

class ManagerApproveLeaveViewModel
{
	constructor (page)
	{
		this.page = page;
		this.leave_to_approve = ko.observableArray();
		this.sorting_method = ko.observable('approaching_first');
		this.leave_types = ko.observableArray();
		this.leave_type_id = ko.observable();
		this.departments = ko.observableArray();
		this.department_id = ko.observable();
		this.managed_departments = ko.observableArray();
		this.date_input = ko.observable();
		let leave_type_initial_update = false;
		let department_initial_update = false;
		this.holidays = ko.observableArray([]);
		this.loader = ko.observable(false);
		
		this.sorting_method.subscribe((newText) => {
			this.page.updateData();
		});
		
		this.leave_type_id.subscribe((newText) => {
			if (leave_type_initial_update == false)
			{
				leave_type_initial_update = true;
				return;
			}
			this.page.updateData();
		});
		
		this.department_id.subscribe((newText) => {
			if (department_initial_update == false)
			{
				department_initial_update = true;
				return;
			}
			this.page.updateData();
		});
	};

	async ping_managers(v, e)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to send a reminder to the manager to respond to these requests?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/general/ping_reminder_to_manager_for_leave_request_made', { employee_id: v.employee_id });
			if (res.status == 'OK')
				Grape.alerts.alert({ type: 'success', message: tr('Successfully sent reminder.'), title: tr('Success') });
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		};
	};

	async approve_leave(v, e)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to approve this leave?')});
		if (response)
		{
			let data = ko.toJS(v);
			let row = $(e.currentTarget).parent().parent();
			if (data.transaction_id)
			{

				let res = await Grape.fetches.postJSON('/manager/approve_leave_item_email', {leave_taken_id: data.transaction_id});
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully approved leave entry.'), title: tr('Success') });
					await this.page.update_leave_data_only();
				}
				else if (res.status == 'ERROR')
				{
					Grape.alerts.apiError(res);

				}
				else
				{
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });

				}
				row.find('.edit').hide();
				row.find('.view').show();
			}
			else
			{
				Grape.alerts.alert({ type: 'error', message: tr('An error occurred with the leave id. Please contact Yooma for more information.'), title: tr('Error') });
			}
		}
		else
			return;
	};

	async reject_leave(v, e)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('LeaveReject', data);
		await this.page.update_leave_data_only();
	};

	show_help()
	{
		Grape.dialog.open('LeaveManagementHelp', {});
	};
};

class ManagerApproveLeave 
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ManagerApproveLeaveViewModel(this);
		window.current_page_title(tr('Leave Requests'));
		
		// Cache these to avoid reloading
		this.holidays_loaded = false;
		this.colors_loaded = false;
	}

	async load_holidays()
	{
		if (this.holidays_loaded) return; // Skip if already loaded
		
		let holiday_res = await Grape.fetches.postJSON('/leave/get_holidays', {});
		if (holiday_res?.get_holidays)
			this.viewModel.holidays(holiday_res.get_holidays);
		else
			this.viewModel.holidays.removeAll();
		
		this.holidays_loaded = true;
	}

	async load_calendar_colors()
	{
		if (this.colors_loaded) return; // Skip if already loaded
		
		let res = await Grape.fetches.postJSON('/general/get_leave_color_combinations', {});
		generateCSScolorCombinations(res);
		this.colors_loaded = true;
	}

	parse_holiday_dates(res)
	{
		let holiday_dates = [];
		if (res != null)
		{
			for (let a = 0; a < res.length; a++)
			{
				if (!holiday_dates[getDate(res[a].holiday_date)])
					holiday_dates[getDate(res[a].holiday_date)] = {
						'date': new Date(res[a].holiday_date),
						'name': res[a].description,
						'css_class': res[a].css_class_name,
						'holiday_type': res[a].holiday_type,
						'type': 'holiday'
					};
			}
		}
		return holiday_dates
	}

	parseLeave(res)
	{
		this.viewModel.leave_to_approve(res);
		
		// insert the dates (EACH EMPLOYEE)
		for (let a = 0; a < res.length; a++)
		{
			let finalized_leave_dates = this.parseFinalizedLeave(res[a].all_finalized_leave);
			
			res[a].temp_event_dates = new Array();
			res[a].temp_event_dates = res[a].temp_event_dates.concat(res[a].dates_included);
			
			let requested_dates = this.parseRequestedDates(res[a].temp_event_dates);
			let holiday_dates = this.parse_holiday_dates(this.viewModel.holidays());
			
			res[a].temp_event_dates = eventDates;
			res[a].temp_event_dates = merge_two_date_objects(res[a].temp_event_dates, finalized_leave_dates);
			res[a].temp_event_dates = merge_two_date_objects(res[a].temp_event_dates, requested_dates);
			res[a].temp_event_dates = merge_two_date_objects(res[a].temp_event_dates, holiday_dates);
			
			let startdate = new Date(res[a].leave_start);
			let endDate = new Date(res[a].leave_end);
			
			let tmp = $(`#datepicker_${res[a].transaction_id}`).datepicker({
				format: 'yyyy-mm-dd',
				defaultViewDate: { year: startdate.getFullYear(), month: startdate.getMonth(), day: startdate.getDate() },
				beforeShowDay: function (date) {
					return setCalendarHighlightDates(date, res[a].temp_event_dates);
				},
				startDate: startdate,
				endDate: endDate
			});
			
			// Resize and align photos in the same loop
			alignEmployeePhoto(res[a].employee_id, '#leave_transaction_' + res[a].transaction_id);
		}
		
		// remove todays date
		$('.active').removeClass('active');
	};

	async get_managed_departments()
	{
		const current_employee_id = Utils.get_local_storage_nullable('employee_id');
		
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'manager_department',
			filter: [{
				field: 'employee_id',
				operand: '=',
				value: Utils.current_employee_id()
			}],
			limit: 50
		});
		
		if (res.status !== 'ERROR' && res.records)
		{
			const departmentIds = [...new Set(res.records.map(record => record.department_id))];
			this.viewModel.managed_departments(departmentIds);
			return departmentIds;
		}
		
		return [];
	}

	async init()
	{
		document.title = tr('Manage Leave Requests');
		
		// Parallel loading for better performance
		const [managed_department_ids, res_type, res_dep] = await Promise.all([
			this.get_managed_departments(),
			Grape.fetches.getJSON('/api/record', {
				table: 'leave_type',
				limit: 100,
				sortfield: 'description',
				sortorder: 'ASC'
			}),
			Grape.fetches.getJSON('/api/record', {
				table: 'v_department_company',
				schema: 'savanna',
				limit: 1000,
				sortfield: 'department',
				sortorder: 'asc'
			})
		]);
		
		if (res_type.status !== 'ERROR')
		{
			res_type.records.unshift({ 'leave_type_id': -1, 'description': getTranslation('l_all_leave_types') });
			this.viewModel.leave_types(res_type.records);
		}
		
		if (res_dep.status !== 'ERROR')
		{
			for (let i = 0; i < res_dep.records.length; i++)
			{
				res_dep.records[i].name = res_dep.records[i].department + ' (' + res_dep.records[i].company + ')';
			}
			
			res_dep.records.unshift({ 'department_id': -1, 'name': getTranslation('l_all_departments') });
			this.viewModel.departments(res_dep.records);
			
			if (managed_department_ids.length > 0)
			{
				if (managed_department_ids.length > 1)
				{
					this.viewModel.department_id(-1);
				}
				else
				{
					this.viewModel.department_id(managed_department_ids[0]);
				}
			}
			else
			{
				this.viewModel.department_id(-1);
			}
		};
	};

	async update_leave_data_only()
	{
		this.viewModel.leave_to_approve.removeAll();
		Navbar.updateLeaveRequestCount(); 
		
		let obj = {
			employee_id: Utils.get_local_storage_nullable('employee_id'),
			leave_type_id: this.viewModel.leave_type_id(),
			sortmethod: this.viewModel.sorting_method(),
			department_id: this.viewModel.department_id()
		};
		
		this.viewModel.loader(true);
		let res = await Grape.fetches.postJSON('/manager/get_leave_to_approve', obj);
		
		if (res)
		{
			this.parseLeave(res);
		}
		this.viewModel.loader(false);
	}

	async updateData()
	{
		this.viewModel.leave_to_approve.removeAll();
		Navbar.updateLeaveRequestCount(); 
		
		// Load holidays and colors in parallel, but only if not already loaded
		await Promise.all([
			this.load_calendar_colors(),
			this.load_holidays()
		]);
		
		let obj = {
			employee_id: Utils.get_local_storage_nullable('employee_id'),
			leave_type_id: this.viewModel.leave_type_id(),
			sortmethod: this.viewModel.sorting_method(),
			department_id: this.viewModel.department_id()
		};
		
		this.viewModel.loader(true);
		let res = await Grape.fetches.postJSON('/manager/get_leave_to_approve', obj);
		
		if (res)
		{
			this.parseLeave(res);
		}
		this.viewModel.loader(false);
	};

	parseFinalizedLeave = (res) =>
	{
		let parsed_dates = new Array();
		for (let a = 0; a < res.length; a++)
		{
			parsed_dates[getDate(res[a].date_start)] = {
				'date': new Date(res[a].date_start),
				'type': 'use_css_class',
				'name': res[a].leave_type + '('+tr('finalised')+')',
				'css_class': res[a].css_class_name
			};
		}
		return parsed_dates;
	};

	parseRequestedDates = (date_array) =>
	{
		let parsed_dates = new Array();
		for (let a = 0; a < date_array.length; a++)
		{
			parsed_dates[getDate(date_array[a])] = {
				'date': new Date(date_array[a]),
				'type': 'use_css_class',
				'name': tr('Requested Leave day'),
				'css_class': 'request_date' };
		}
		return parsed_dates;
	}
};

export default {
	route: '[/]manager/approve_leave',
	page_class: ManagerApproveLeave,
	template: template,
	template_filename: 'translation/approve_leave'
};